import styled from "styled-components";
import { ContractTypeBadge } from "../ContractsList/Styles";

export { ContractTypeBadge };

export const ContractDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 1.5rem 0 4rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: ${(props) => props.theme.spacing.small} 0 80px;
  }
`;

export const ContractDetailsHeader = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 500;
  margin-bottom: 1.5rem;
  cursor: pointer;
  transition: color 0.2s;
  width: 100%;
  max-width: 760px;

  &:hover {
    color: #111827;
  }
`;

export const ContractDetailsContent = styled.div`
  width: 100%;
  max-width: 760px;
  background-color: #FFFFFF;
  border-radius: 0.75rem;
  padding: 3rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #E5E7EB;

  @media (max-width: 1100px) {
    padding: 1.5rem;
  }
`;

export const ContractTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: ${(props) => props.theme.spacing.medium};
`;

export const ContractDetailsTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.025em;
  margin: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: ${(props) => props.theme.fontSizes.xlarge};
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const ContractInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem 4rem;
  margin-top: ${(props) => props.theme.spacing.large};
  margin-bottom: 2.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${(props) => props.theme.spacing.medium};
  }
`;

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`;

export const InfoLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const InfoValue = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
`;

export const ClausesSection = styled.div`
  margin-top: 2.5rem;
  border-top: 1px solid #E5E7EB;
  padding-top: 2rem;
`;

export const ClauseHeading = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
  margin: 2rem 0 0.75rem 0;

  &:first-child {
    margin-top: 0;
  }
`;

export const ClauseParagraph = styled.p`
  font-size: 0.9375rem;
  color: #374151;
  line-height: 1.7;
  text-align: justify;
  margin: 0 0 0.75rem 0;
`;
